export default {
  'ikg.export': '导出',
  'ikg.import': '导入',
  'ikg.downTemplate': '下载模板',
  'ikg.add': '新增',
  'ikg.edit': '编辑',
  'ikg.delete': '删除',
  'ikg.save': '保存',
  'ikg.cancel': '取消',
  'ikg.confirm': '确认',
  'ikg.sure': '确定',
  'ikg.search': '搜索',
  'ikg.reset': '重置',
  'ikg.query': '查询',
  'ikg.operation': '操作',
  'ikg.input': '请输入{{name}}',
  'ikg.select': '请选择{{name}}',
  'ikg.addSibling': '新增同级目录',
  'ikg.addChildren': '新增子级目录',
  'ikg.pass': '通过',
  'ikg.error': '错误',
  'ikg.loginAgain': '账号长时间未操作，请重新登录',
  'ikg.noAuth': '无权限',
  'ikg.to': '至',
  'ikg.userManage': '用户管理',
  'ikg.standard': '数据标准',
  'ikg.roleManage': '角色管理',
  'ikg.create': '新建',
  'ikg.success': '{{action}}成功',
  'ikg.deleteConfirm': '确认删除吗？',
  'ikg.unDeleteConfirm': '确认撤销删除吗？',
  'ikg.passConfirm': '确认通过吗？',
  'ikg.warn': '提示',
  'ikg.logoutConfirm': '确定要退出登录吗？',
  'ikg.logout': '退出登录',
  'ikg.changePwd': '修改密码',
  'ikg.index': '序号',
  'ikg.rename': '重命名',
  'ikg.version': '版本',
  'ikg.total': '共{{count}}条',
  'ikg.toTop': '回到顶部',
  'ikg.selectCount': '已选{{count}}项',
  'ikg.move': '移动',
  'ikg.moveToDir': '移动到目标目录',
  'ikg.movePlaceholder': '请选择或输入目录名称',
  'ikg.merge': '合并',
  'ikg.mergeToDir': '合并到目标目录',
  'ikg.mergePlaceholder': '请选择或输入目录名称',
  'ikg.moveTip':'移动会将当前选定目录移动到目标目录下，成为其子目录。当前目录下的所有子集也会跟随移动。',
  'ikg.mergeTip':'合并会将当前选定目录下的所有子级移动到目标目录下，并删除当前目录。',

  // dict
  'dict.viewTitle': '字典浏览',
  'dict.editTitle': '字典编辑',
  'dict.auditTitle': '字典审核',
  'dict.knowledgeView': '知识浏览',
  // 'dict.knowledgeMaintain': '知识维护',
  'dict.knowledgeAudit': '知识维护',
  'dict.addDirSingle': '新建字典',
  'dict.addDirVersion': '新建版本',
  'dict.code': '编码',
  'dict.name': '名称',
  'dict.type': '分类',
  'dict.source': '来源',
  'dict.updateTime': '更新日期',
  'dict.dictType': '字典域',
  'dict.publishTime': '发布日期',
  'dict.exportBy': '导出人',
  'dict.exportTime': '导出时间',
  'dict.searchTree': '请输入编码/名称',
  'dict.cancelDel': '撤销删除',
  'dict.addWord': '新增词条',
  'dict.exportPkg': '导出字典包',
  'dict.pkgName': '导出字典包名称',
  'dict.pkgNameExtra': '命名规范：项目名称_字典域_字典名称_字典版本号_导出日期',
  'dict.project': '使用项目',
  'dict.desc': '说明',
  'dict.submitVersion': '提交版本',
  'dict.addVersion': '新增版本',
  'dict.publishVersion': '发布版本',
  'dict.submitVersionTxt': '提交后无法再次提交，确认提交此版本字典？',
  'dict.filterSwitch': '仅显示待通过项',
  'dict.createMethod': '创建方式',
  'dict.inherit': '继承已有版本',
  'dict.createNew': '重新创建',
  'dict.dictName': '字典名称',
  'dict.inheritVersion': '继承版本',
  'dict.versionNo': '创建版本号',
  'dict.addDir': '新建字典域',
  'dict.publishText': '当前版本还存在待审核项，是否通过所有词条修订并发布版本?',
  'dict.publishText2': '是否确认发布版本',
  'dict.quote': '引用',
  'dict.dictVersion': '字典版本',
  'dict.auditPass': '审核通过',
  'dict.exportMethod': '导出方式',
  'dict.onlyItemExport': '仅词条导出',
  'dict.dirAndItemExport': '目录和词条导出',
  'dict.batchAuditMax': '最多同时审核100条',
  'dict.version': '版本号',
  // meddra导入
  'dict.mdhierAsc': 'mdhier.asc',
  'dict.lltAsc': 'llt.asc',
  'dict.mpcsv': 'MP.csv',
  // whodrugc3导入
  'dict.suncsv': 'SUN.csv',
  'dict.thgcsv': 'ThG.csv',
  'dict.ccodecsv': 'CCODE.csv',
  'dict.pfcsv': 'PF.csv',
  'dict.atccsv': 'ATC.csv',
  // whodrugb3导入
  'dict.ddcsv': 'DD.csv',
  'dict.bnacsv': 'BNA.csv',
  'dict.inacsv': 'INA.csv',
  'dict.ddacsv': 'DDA.csv',
  'dict.ddsourcecsv': 'DDSOURCE.csv',
  'dict.INGcsv': 'ING.csv',
  // omop导入
  'dict.conceptcsv': 'CONCEPT.csv',
  'dict.conceClasscsv': 'CONCEPT_CLASS.csv',
  'dict.domaincsv': 'DOMAIN.csv',
  'dict.conceRelcsv': 'CONCEPT_RELATIONSHIP.csv',
  'dict.selectFile': '选择文件',
  'dict.drugName': '药品名称',
  'dict.drugNameType': '名称类型',
  'dict.MPID': 'MPID',
  'dict.mah': '药品上市许可持有人（MAH）',
  'dict.directoryInfo': '目录',
  'dict.itemInfo': '词条',
  'dict.createTime': '操作时间',
  'dict.exportType': '引用方式',
  'dict.operator': '操作人',
  // 导出记录
  'export.title': '引用记录',
  'export.searchProject': '请输入项目编号或名称',
  'export.projectName': '项目名称',
  'export.projectDeleted': '该项目已删除',
  // user
  'user.oldPwd': '旧密码',
  'user.newPwd': '新密码',
  'user.confirmPwd': '确认密码',
  'user.pwdNotSame': '两次密码不一致',
  'user.pwdRequired': '密码不能为空',
  'user.pwdRegex': '密码必须包含大写字母、小写字母、数字和特殊字符，长度8-16位',

  // knowledge
  'knowledge.txt1': '不良事件',
  'knowledge.txt2': '定义',
  'knowledge.txt3': '引申注释',
  'knowledge.txt4': '分级1',
  'knowledge.txt5': '分级2',
  'knowledge.txt6': '分级3',
  'knowledge.txt7': '分级4',
  'knowledge.txt8': '分级5',
  'knowledge.txt9': '系统器官分类',
  'knowledge.txt10': '通用名',
  'knowledge.txt11': '商品名',
  'knowledge.txt12': '英文名',
  'knowledge.txt13': '有效成分',
  'knowledge.txt14': '生产厂家',
  'knowledge.txt15': '规格',
  'knowledge.txt16': '剂型',
  'knowledge.txt17': '国批文号',
  'knowledge.txt18': '药品本位码',
  'knowledge.txt19': '附件',
  'knowledge.txt20': '名字',
  'knowledge.instruction': '说明书',
  'knowledge.drugName': '药品名称',
  'knowledge.ingredients':'成分',
  'knowledge.indications': '适应症',
  'knowledge.usage': '用法用量',
  'knowledge.adverseReactions': '不良反应',
  'knowledge.taboo': '禁忌',
  'knowledge.formatFileError': '导入文件格式错误',
  'knowledge.mattersNeedAttention': '注意事项',
  'knowledge.txt21': '老年用药',
  'knowledge.txt22': '药物相互作用',
  'knowledge.txt23': '药物过量',
  'knowledge.txt24': '药理毒理',
  'knowledge.txt25': '药代动力学',
  'knowledge.txt26': '贮藏',
  'knowledge.txt27': '包装',
  'knowledge.txt28': '有效期',
  'knowledge.txt29': '执行标准',
  'knowledge.txt30': '生产企业',
  'dict.lowLevelLang':'低位语',
  'dict.lltCurrency':'是否现用',
  'dict.drugRecordNo':'药品编码',
  'dict.substanceName':'活性成分',
  'dict.country':'销售国家',
  'dict.dosageForm':'剂型',
  'dict.conceptCode':'概念Code',
  'dict.classType':'类别',
  'dict.conceptType':'概念类型',
  'dict.conceptDomain':'概念域',
  'dict.quoteItem':'引用选中词条',
  'dict.quoteDir':'引用当前目录',
  'dict.quoteDict':'引用字典',
  'dict.itemId':'词条ID',
  'dict.preferredName':'【通用名】',
  'ikg.back':'返回',
  'dict.createKnowledgeDomain':'新建知识域',
  'dict.createKnowledgeBase':'新建知识库',
  'knowledge.regName':'名称只能包含中文、英文、数字和下划线',
  'ikg.createDoc':'创建文档',
  'ikg.confirmUpload':'确认上传',
  'ikg.confirmContent':'继续上传会覆盖重名的文档',
  'ikg.fileLimit':'文件大小不能超过30MB',
  'ikg.uploadSuccess':'上传成功',
  'ikg.keywordRetrieval':'关键字检索',
  'ikg.updateTime':'更新时间',
  'ikg.confirmDeleteContent':'确定要删除',
  'ikg.unSupport':'暂不支持当前文档浏览，请下载后查看',
  'ikg.downloadFile':'下载文档',
  'dict.editKnowledgeBase':'编辑知识库'
  
}
